






import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";



@Component
export default class BaseTLFilter extends Vue {
	@Prop({ type: String, required: true, default: "" }) label?: string; //hlavní popis
	@Prop({ type: String, required: false, default: "6" }) labelWidth?: string; //šířka
	@Prop({ type: String, required: false, default: "2" }) labelcols?: string; //počet řádků - velikost 

	@Prop({ type: String, required: false, default: "" }) filterOnName1?: string;

	@Prop({ type: Boolean, required: false, default: null }) invalid?: boolean; //TODO

	@Prop({ type: Boolean, required: false, default: false }) isBig?: boolean; //větší pismo
	//@Prop({ type: Boolean, required: false, default: false }) isColoredFont?: boolean; //barevne písmo


	//@Prop({ type: String, required: false, default: "" }) forinput?: string; //pro koho je to popisek
	//@Prop({ type: String, required: false, default: "sm" }) size?: string; //velikost pisma sm, lg
	//@Prop({ type: String, required: false, default: "left" }) align?: string; //zarovnání 
	

	//načtení stylu
	get inputClass() {
		return {
			"colored-font": false, //this.isColoredFont == true,
			"label-design-head": true ,
			"label-design-head-bigger": this.isBig == true
		};
	}



}
